import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import less from 'less'
import 'amfe-flexible'
import {Popup} from "vant";
import { Toast,Dialog }from 'vant'
import {Select,Option,Progress} from "element-ui";

Vue.use(Select)
Vue.use(Option)
Vue.use(Progress)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(less)
Dialog.setDefaultOptions({
  className:'s_dialog'
})
Vue.use(Dialog)

Toast.setDefaultOptions({
  closeOnClick:true,
  className:'toast'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
